import { BaseResourceModel } from './base-resource.model';

export class Genero extends BaseResourceModel {
    constructor(
        public nome?: string,
        public descricao?: string,
        public situacao?: string
    ) {
        super();
    }

    static fromJson(jsonData: any): Genero {
        return Object.assign(new Genero(), jsonData);
    }
}
